export enum SizerDirection {
  Bottom = 'bottom',
  Top = 'top',
  Left = 'left',
  Right = 'right',
}

 interface DragData {
  x : number,
  y: number,
  dragging: boolean,
  nodeRect?: DOMRect
}

export interface Vector {
  x : number,
  y: number,
}


export class NodeSizer {
  node? : HTMLElement ;
  sizer? : HTMLElement;
  region : SizerDirection = SizerDirection.Top;
  min : number = 0;
  max : number = 10000;

  dragData : DragData = {dragging:false, x:0, y:0};

  constructor(pNode: HTMLElement, pSizer :HTMLElement, pRegion? : SizerDirection, pMin? : number, pMax? : number) {
    let self = this;
    self.node = pNode;
    self.sizer = pSizer;

    if (pSizer.hasAttribute('min')) {
      self.min = parseInt(String(self.sizer.getAttribute('min')));
    }
    if (pSizer.hasAttribute('max')) {
      self.max = parseInt(String(self.sizer.getAttribute('max')));
    }
    if (pRegion != undefined) {
      self.region = pRegion;
    }
    if (pMin != undefined) {
      self.min = pMin;
    }
    if (pMax != undefined) {
      self.max = pMax;
    }

    self.regEvents();
  }

  private regEvents() {
    let self = this;

    self.sizer?.addEventListener("mousedown", function(e) {
      self.dragData.dragging = true;
      self.dragData.x = e.screenX;
      self.dragData.y = e.screenY;
      self.dragData.nodeRect = self.node?.getBoundingClientRect();
    });

    self.sizer?.addEventListener("mouseup", function(e) {
      self.dragData.dragging = false;
    });

    self.sizer?.addEventListener("mousemove", function(e) {
      if (!self.dragData.dragging) {
        return;
      };
      let rect = self.node?.getBoundingClientRect();
      if (!rect) { return };
      if (!self.node ) { return; }
      if (self.region == SizerDirection.Top || self.region == SizerDirection.Bottom) {
        let delta = e.screenY - self.dragData.y;
        let newheight = (rect?.height + delta);
        if (self.max > 0 && newheight > self.max) {
          newheight = self.max;
        }
        if (self.min != 0 && newheight < self.min) {
          newheight = self.min;
        }
        self.node.style.height = newheight + "px";
      } else if (self.region == SizerDirection.Left || self.region == SizerDirection.Right) {
        let delta = e.screenX - self.dragData.x;
        let newwidth = (rect?.width + delta);
        if (self.max > 0 && newwidth > self.max) {
          newwidth = self.max;
        }
        if (self.min != 0 && newwidth < self.min) {
          newwidth = self.min;
        }
        self.node.style.width = newwidth + "px";
      }

      self.dragData.nodeRect = self.node?.getBoundingClientRect();
      self.dragData.x = e.screenX;
      self.dragData.y = e.screenY;
    });

  }
}


export class NodeMover {
  node? : HTMLElement ;
  handleNode? : HTMLElement;


  dragData : DragData = {dragging:false, x:0, y:0};

  constructor(pNode: HTMLElement, pHandleNode :HTMLElement) {
    let self = this;
    self.node = pNode;
    self.handleNode = pHandleNode;

    self.regEvents();
  }

  private mouseDown(e : MouseEvent) {
    this.dragData.dragging = true;
    if (this.handleNode) {
      this.handleNode.style.cursor = 'move';
      //this.handleNode.style.pointerEvents = 'none';
    }
    if (this.node) {
      this.node.style.cursor = 'move';
      //this.node.style.pointerEvents = 'none';
      if (!this.node.style.width.includes('px')) {
        this.node.style.width = String(this.dragData?.nodeRect?.width) + "px";
      }
      if (!this.node.style.height.includes('px')) {
        this.node.style.height = String(this.dragData?.nodeRect?.height) + "px";
      }
    }
    
  }

  private mouseUp(e : MouseEvent) {
    this.dragData.dragging = false;
    if (this.handleNode) {
      this.handleNode.style.cursor = '';
      //this.handleNode.style.pointerEvents = 'initial';
    }
    if (this.node) {
      this.node.style.cursor = '';
      //this.node.style.pointerEvents = 'initial';
    }
  }

  private onMove(event : TouchEvent | MouseEvent) {
    let self = this;
    if (!self.dragData.dragging) {        
      return;
    };

    if (!self.node ) { return; }
    var e : any = event;
    if ( e.type === 'touchmove') {
      //@ts-ignore
      e = event.changedTouches[0];
    }
    
    // let rect = self.node?.getBoundingClientRect();
    // if (e.clientX > rect.x + rect.width && e.clientX < rect.x 
    //   && e.clientY > rect.y + rect.height && e.clientY < rect.y) {
    //   self.dragData.dragging = false; 
    //   return;
    // }

    let delta : Vector = {
      y: e.clientY - self.dragData.y ,
      x: e.clientX - self.dragData.x 
    };
    let newV : Vector = {
      x: self.node.offsetLeft + delta.x ,
      y: self.node.offsetTop + delta.y 
    };

    if (newV.x < 0) {
      newV.x = 0;
    } else if (newV.x > window.innerWidth - self.node.clientWidth) {
      newV.x = window.innerWidth - self.node.clientWidth;
    }

    if (newV.y < 0) {
      newV.y = 0;
    } else if (newV.y > window.innerWidth - self.node.clientHeight) {
      newV.y = window.innerHeight - self.node.clientHeight;
    }
         
    self.node.style.right = '';
    self.node.style.bottom = '';
    self.node.style.left = newV.x + "px";
    self.node.style.top = newV.y + "px";

    self.dragData.x = e.clientX;
    self.dragData.y = e.clientY;
  }
  private regEvents() {
    let self = this;

    self.handleNode?.addEventListener("mousedown", function(e) {
      e.preventDefault();
      self.dragData.x = e.clientX;
      self.dragData.y = e.clientY;
      self.dragData.nodeRect = self.node?.getBoundingClientRect();
      self.mouseDown(e);
    });

    /*self.handleNode?.addEventListener("mouseup", function(e) {
      e.preventDefault();
      self.mouseUp(e);
    });*/

    self.node?.addEventListener("mouseup", function(e) {
      e.preventDefault();
      self.mouseUp(e);
    });

    //self.handleNode?.addEventListener("mouseleave", function(e) {
    //  self.mouseUp(e);
    //});
    
    self.node?.addEventListener("mouseleave", function(e) {
      //e.preventDefault();
      self.mouseUp(e);
    });
    

    self.node?.addEventListener("mousemove", function(e) {
      e.preventDefault();
      self.onMove(e);
    });

    self.node?.addEventListener("touchmove", function(e) {
      e.preventDefault();
      self.onMove(e);
    });

  }
}
